import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CommunityRedirectService
{
    private sessionStorageKey: string = 'community-redirect-data'; 

    public setRedirectData(value: string): void {
        sessionStorage.setItem(this.sessionStorageKey, value);
    }

    public setRedirectDataByType<T>(value: T): void {
        sessionStorage.setItem(this.sessionStorageKey, JSON.stringify(value));
    }

    public getRedirectData(): string {
        let data = sessionStorage.getItem(this.sessionStorageKey);
        if (data) {
            this.removeFromStorage();
        }

        return data;
    }

    public getRedirectDataByType<T>(): T {
        let data = JSON.parse(sessionStorage.getItem(this.sessionStorageKey));
        if (data) {
            this.removeFromStorage();
        }

        return data;
    }

    private removeFromStorage(): void {
        sessionStorage.removeItem(this.sessionStorageKey);
    }
}
